import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import MenuGroup from './menu-group';
/**
 * @deprecated
 */

const PopupMenuGroup = ({
  maxWidth = 800,
  minWidth = 320,
  ...rest
}) => // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
jsx(MenuGroup, _extends({
  maxWidth: maxWidth,
  minWidth: minWidth
}, rest));

export default PopupMenuGroup;